module.exports = __webpack_public_path__ + "img/full-caregogi-2.022b486d.jpg";